$("body").on("click", ".open-shipment-menu", function () {
    var $this = $(this);
    var menu = $this.parents(".shipment-menu-wrapper");

    $(".shipment-menu", menu).css({
        top: menu.position().top,
        left:
            5 + (menu.position().left + menu.width()) - $(".shipment-menu", menu).width()
    });

    menu.addClass("opened");
    closeDropdown($this.parents(".shipment-menu-wrapper").attr("data-dropdown"));
    return false;
});


$('body').on('click', '.cancel-shipment-trigger', function () {
    var data = $(this).parents('.shipment');
    var action = $('.cancel-shipment form').attr('data-action').replace('{shipment}', data.attr('data-shipment'));
    $('.cancel-shipment form').attr('action', action);
    openModal('.cancel-shipment');
    closeDropdown();
    return false;
});

$('body').on('submit', '.cancel-shipment form', function() {
    var $this = $(this);
    var modal = $this.parents('.modal');
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;

    modal.find('.required').each(function() {
        if($(this).val() === '') {
            error = true;
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            if(!data.success) {
                showError('Error', data.message);
                return false;
            }

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});

channel.bind('process-shipment', function(data) {
    console.log(data);
    var element;

    if($('.shipment[data-shipment="'+data.shipment+'"]').length) {
        element = $('.shipment[data-shipment="'+data.shipment+'"]');

        element.find('[data-input="full_name"]').html(data.full_name);
        element.find('[data-input="email"]').html(data.email);
        element.find('[data-input="phone"]').html(data.phone);
        element.find('[data-input="reference_1"]').html(data.reference_1);
        element.find('[data-input="reference_2"]').html(data.reference_2);
        element.find('[data-input="street"]').html(data.street);
        element.find('[data-input="apt"]').html(data.apt);
        element.find('[data-input="city"]').html(data.city);
        element.find('[data-input="state"]').html(data.state);
        element.find('[data-input="zip"]').html(data.zip);
        element.find('[data-input="tracking_number"]').html(data.tracking_number);
        element.find('[data-input="service_level"]').html(data.service_level);
        element.find('[data-input="price_parsed"]').html(data.price_parsed);
        element.find('[data-input="status"]').html(data.status);
        element.find('[data-input="eta_parsed"]').html(data.eta_parsed);
        element.find('[data-input="eta_human"]').html(data.eta_human);
        element.find('[data-input="total_shipment_parcels"]').html(data.total_shipment_parcels);

        element.find('.shipment-menu').html(buttons(data.buttons));
        return;
    }

    if($('body').attr('data-page') === '1') {
        element = $('<tr>', {
            class: 'shipment',
            'data-shipment': data.shipment
        });

        element.append(`<td>
            <p data-input="full_name">${data.full_name}</p>
            <p class="small-text" data-input="email">${data.email}</p>
            <p class="small-text" data-input="phone">${data.phone}</p>
        </td>

        <td>
            <p data-input="reference_1">${data.reference_1}</p>
            <p class="small-text" data-input="reference_2">${data.reference_2}</p>
        </td>
        
        <td>
            <p>
                <span data-input="street">${data.street}</span>
                <span data-input="apt">${data.apt}</span>
            </p>

            <p class="small-text">
                <span data-input="city">${data.city}</span>
                <span data-input="state">${data.state}</span>
                <span data-input="zip">${data.zip}</span>
            </p>
        </td>

        <td class="flex-wrapper">
            <div class="flex">
                <figure class="icon-image">
                    <img src="images/icons/${data.carrier}.svg" alt="">
                </figure>
                <div>
                    <p data-input="tracking_number">${data.tracking_number}</p>
                    <p class="small-text" data-input="service_level">${data.service_level}</p>
                </div>
            </div>
        </td>

        <td data-input="total_shipment_parcels">${data.total_shipment_parcels}</td>
        
        ${$('th.price').length ? `<td data-input="price_parsed">${data.price_parsed}</td>` : ``}
        
        <td>
            <span class="highlight" data-color="${data.status_color}" data-input="status">
                ${data.status}
            </span>
        </td>

        <td>
            <p data-input="eta_parsed">${data.eta_parsed}</p>
            <p class="small-text" data-input="eta_human">${data.eta_human}</p>
        </td>
        <td class="shipment-menu-wrapper menu-wrapper" data-dropdown="shipment-${data.shipment}">
            <a href="" class="icon-more open-shipment-menu open-menu"></a>
            <ul class="shipment-menu menu">
                 ${buttons(data.buttons)}
            </ul>
        </td>`);

        $('.shipments tbody').prepend(element);
    }
});